import { render, staticRenderFns } from "./activity-tab.vue?vue&type=template&id=36f6dd96"
import script from "./activity-tab.vue?vue&type=script&lang=js"
export * from "./activity-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports